import React from "react";
import {
  Grid
} from "semantic-ui-react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { authLogin } from "../store/actions/auth";
import withRouter from "../withRouter"

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import axios from "axios";
import "../styles/CA2Login.scss";
import { openError } from "../store/actions/notification";


class LoginForm extends React.Component {
  state = {
    username: "",
    password: "",
    theme: createTheme({
      palette: {
        primary: {
          main: "#F7931E",
        },
        secondary: {
          main: "#F9F9F9",
        },
      },
    }),
    logoutFlag: false
  };

  componentDidMount() {

    let { logoutFlag } = this.state
    const urlParams = new URLSearchParams(this.props.location?.search);
    logoutFlag = urlParams.get("logout")
    this.setState({ logoutFlag })
    if (logoutFlag) {
      setTimeout(() => {
        this.setState({ logoutFlag: false })
      }, 2000);
    }

  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { username, password } = this.state;
    this.setState({ formError: '' });
    if (!username) {
      this.setState({ formError: 'Please enter your email' });
      return;
    }
    if (!password) {
      this.setState({ formError: 'Please enter your password' });
      return;
    }
    this.props.login(username, password);
  };

  createOTP = (useremail, password) => {
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/api/user/create-otp/`, {
        useremail,
        fromlogin: true
      })
      .then(res => {
        if (res.data.status === 200) {
          const { otp_token } = res.data;
          const params = { useremail, password, otp_token };
          console.log('params: ', params);
          this.props.navigate("/log/verify-otp", { state: params })
        } else {
          console.log('createOTP: ', res.data);
        }
      })
      .catch((error) => {
        console.log('createOTP error: ', error);
        setTimeout(() => {
          this.props.openError(true, "Update Failed!", "There was an error happened while generating otp.", "Just now")
        }, 300);
      });
  }

  cancelSubmit = () => {
    this.setState({ username: "", password: "" })
  }

  render() {
    const { error, token } = this.props;
    const { theme, logoutFlag, username, password } = this.state;

    if (token) {
      return <Navigate to="/mysystems?from=login" />;
    }
    return (
      <ThemeProvider theme={theme}>
        <div className="login-page">
          {/* <section className="header-section">
            <img src={require("../assets/imgs/vtg-logo.png")} width="300" alt="logo" />
          </section> */}

          <section className="main-section">
            <div className="main-content">
              <div style={{ margin: '24px auto' }}>
                <img src={require("../assets/imgs/vtg-logo.png")} width="240" alt="logo" />
              </div>

              <div className="left-side">
                <h2>
                  Client Access Online Condition Monitoring
                </h2>
              </div>

              <form className="right-side" onSubmit={this.handleSubmit.bind(this)}>
                <TextField label="Email" variant="standard" autoComplete="new-password" className="custom-field" value={username} name="username"
                  onChange={this.handleChange}
                />
                <br />
                <TextField label="Password" variant="standard" autoComplete="new-password" type="password" className="custom-field" value={password} name="password"
                  onChange={this.handleChange}
                />
                {this.state.formError && (
                  <p style={{ color: '#ff6b6b', fontSize: '13px', textAlign: 'center', margin: '8px 0 0' }}>{this.state.formError}</p>
                )}
                <div className="sign-in-btn">
                  <Button variant="outlined" onClick={this.handleSubmit.bind(this)} disabled={this.props.loading}>
                    {this.props.loading ? <CircularProgress size={20} style={{ color: 'white' }} /> : 'Login'}
                  </Button>
                </div>
                {/* <FormControlLabel
                  value="start"
                  control={<Checkbox />}
                  label="Remember Me"
                  labelPlacement="start"
                  className="remember-me"
                /> */}
                <p className="forgot-password" onClick={() => this.props.navigate("/forgot-pwd")} >Forgot Password?</p>
                <div style={{ display: 'flex' }}>
                  <hr style={{ width: '45%' }}></hr>
                  <span>Or</span>
                  <hr style={{ width: '45%' }}></hr>
                </div>
                <p className="sign-up">
                  <a href="/" onClick={(e) => { e.preventDefault(); this.props.navigate("/signup"); }}>Register For A New Account</a>
                </p>
              </form>
            </div>
          </section>
        </div>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    token: state.auth.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: (username, password) => dispatch(authLogin(username, password)),
    openError: (open, title, content, timeStr) => dispatch(openError(open, title, content, timeStr))
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm));
